import {Component, Inject, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {BsModalRef, ModalDirective} from 'ngx-bootstrap/modal';
import {Order, SelectedItem} from '../../models/order';
import {Observable, Subscription} from 'rxjs';
import {FormGroup} from '@angular/forms';
import {GroupConfig} from '../../../shared/models/config';
import {L10N_LOCALE, L10nLocale} from 'angular-l10n';
import {select, Store} from '@ngrx/store';
import * as fromOrders from '../../reducers';
import {GetFormsService} from '../../../shared/services/get-forms.service';
import {Router} from '@angular/router';
import {GetConfigOrderService} from '../../services/get-config-order.service';
import {CloseOrdersAction} from '../../actions/close-order';
import {OrderClearAction} from '../../actions/order-load';
import {ClearSelectItemAction} from '../../../shared';
import * as moment from 'moment';
import {ClearOneItemSubListAction} from '../../../shared/actions/subscription-list';
import {skipWhile} from 'rxjs/operators';
import * as _ from 'lodash';
import * as fromRoot from '../../../shared/reducers';
import {ResetOrdersAction} from '../../actions/reset-rder';

@Component({
  selector: 'storever-reset-order-modal',
  templateUrl: './reset-order-modal.component.html',
  styleUrls: ['./reset-order-modal.component.css']
})
export class ResetOrderModalComponent implements OnInit, OnDestroy {

  @ViewChild('staticModal', {static: false}) public staticModal: ModalDirective;
  @Input() selectedItemUuid: string;
  @Input() selectedOrders: Order[];
  order$: Observable<Order>;
  selectedItem$: Observable<SelectedItem[]>;
  selectedOneItem$: Observable<SelectedItem>;
  // tslint:disable-next-line:no-any
  selectedItem: any[];
  // tslint:disable-next-line:no-any
  selectedOneItem: any;
  // tslint:disable-next-line:no-any
  form: FormGroup;
  formConfig: GroupConfig;
  selectedItemsUuid: string[];
  private sub$: Subscription;
  private subscriptions = [];


  constructor(@Inject(L10N_LOCALE) public locale: L10nLocale,
              private store: Store<fromOrders.AppState>,
              private getFormsService: GetFormsService,
              private router: Router,
              private bsModalRef: BsModalRef,
              private getConfigOrder: GetConfigOrderService) {
  }

  get isAnomalies(): boolean {
    if (this.router) {
      return  this.router.url.split('?')[0].split('/')[1] === 'anomalies'
    } else {
      return false
    }
  }

  ngOnInit(): void {
    this.getAnomaliesData();
    this.form = this.getFormsService.getCloseOrder();
    this.formConfig = this.getConfigOrder.getConfigCloseOrder();
    this.order$ = this.store.pipe(select(fromOrders.selectors.getOrder));
  }

  send(): void {
    this.store.dispatch(new ResetOrdersAction({ orderUuids: this.selectedItemsUuid }));
    if (this.isAnomalies) {
      this.closeBSF();
    } else {
      this.close();
    }

  }
  close(): void {
    this.staticModal.hide();
  }

  // this fonction is used when we call this modal via data table
  closeBSF(): void {
    this.bsModalRef.hide();
  }
  open(): void {
    this.getSelectedOrderInfo();
    this.staticModal.show();
  }

  ngOnDestroy(): void {
    if (this.subscriptions.length) {
      this.subscriptions.forEach(sub => sub.unsubscribe());
    }
  }
  getSelectedOrderInfo(): void {
    this.selectedItemsUuid = [];
    this.sub$ = this.order$.pipe(
      skipWhile(value => _.isEmpty(value))
    ).subscribe((order: Order) => {
      this.selectedItemsUuid = [];
      if (order) {
        this.selectedItemsUuid.push(order.uuid);
      }
    });

    if (this.selectedItemsUuid.length === 0 && this.selectedOrders) {
      for (let i = 0; i < this.selectedOrders.length; i++) {
        this.selectedItemsUuid.push(this.selectedOrders[i].uuid)
      }
    }
    this.subscriptions.push(this.sub$);
  }

  getAnomaliesData(): void {
    this.selectedItemsUuid = [];
    this.selectedItem$ = this.store.pipe(select(fromRoot.selectors.getSelectedSubList));
    // tslint:disable-next-line:no-any
    this.sub$ = this.selectedItem$.subscribe((data: any[]) => {
      if (data) {
        this.selectedItem = data;
        for (let j = 0; j < this.selectedItem.length; j++) {
          this.selectedItemsUuid.push(this.selectedItem[j].orderUuid);
        }
      }

    });
    this.subscriptions.push(this.sub$);
    this.selectedOneItem$ = this.store.pipe(select(fromRoot.selectors.getSelectedOneSubscription));
    // tslint:disable-next-line:no-any
    this.sub$ = this.selectedOneItem$.subscribe((data: any) => {
      if (data) {
        this.selectedOneItem = data;
        this.selectedItemsUuid.push(data.orderUuid);
      }

    });
    this.subscriptions.push(this.sub$);
  }
}

